import React from 'react'
import Footer from '../components/Footer';
import Header from '../components/Header';
import GrievanceStatusForm from '../components/GrievanceStatusForm';

export default function GrievanceStatusPage() {
  return (
    <div>
      <Header />
      <>
        <GrievanceStatusForm />
      </>
      <Footer />
    </div>
  )
}